/* import __COLOCATED_TEMPLATE__ from './smart-suggestions-section.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface Suggestion {
  id: number;
  text: string;
  display_priority: number;
}

interface Args {
  smartSuggestionsEnabled: boolean;
  suggestions: Suggestion[];
  showAllSuggestions: boolean;
  isGeneratingSuggestions?: boolean;
  onToggle: () => void;
  onReorder: (reorderedSuggestions: Suggestion[]) => void;
  onToggleShowAll: () => void;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

export default class SmartSuggestionsSection extends Component<Signature> {
  get displayedSuggestions(): Suggestion[] {
    if (this.args.showAllSuggestions) {
      return this.args.suggestions;
    }
    return this.args.suggestions.slice(0, 3);
  }

  get hasAnySuggestions(): boolean {
    return this.args.suggestions.length > 0;
  }

  get hasMoreThanThree(): boolean {
    return this.args.suggestions.length > 3;
  }

  isLastTopItem = (index: number): boolean => {
    return index === 2 && this.hasMoreThanThree;
  };

  @action
  handleReorder(reorderedItems: Suggestion[]) {
    if (!this.args.showAllSuggestions && this.args.suggestions.length > 3) {
      // Only top 3 were in the sortable-group; merge back with remaining
      let remaining = this.args.suggestions.slice(3);
      this.args.onReorder([...reorderedItems, ...remaining]);
    } else {
      this.args.onReorder(reorderedItems);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Sales::SmartSuggestionsSection': typeof SmartSuggestionsSection;
  }
}
